import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeviceService } from '@app/core/services/device.service';
import { NgClass, NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'pezi-button',
  host: {
    '[style.pointer-events]': '\'none\''
  },
  templateUrl: './pezi-button.component.html',
  styleUrls: ['./pezi-button.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    MatIcon
  ]
})
export class PeziButtonComponent implements OnInit {

  @Input()
  disabled = false;

  @Input()
  text: string;

  @Input()
  loading: boolean;

  @Input()
  isDottedLoader: boolean;

  @Input()
  isSubmit: boolean;

  @Input()
  isSmallButton: boolean;

  @Input()
  isOutlined: boolean;

  @Input()
  isPlain: boolean;

  @Input()
  isSecondary: boolean;

  @Input()
  isAccent: boolean;

  @Input()
  isAccentSecondary: boolean;

  @Output()
  clickEvent = new EventEmitter();

  @Input()
  fullWidth = false;

  @Input()
  mobileShrink = false;

  @Input()
  icon: string;

  @Input()
  nvIcon: string;

  @Input()
  alignIconRight: boolean;

  @Input()
  classList?: string[];

  @Input()
  classListMobile?: string[];

  constructor(public deviceService: DeviceService) { }

  ngOnInit() {
    /*if (this.classListMobile) {
      console.log('CC',this.classListMobile.join(' '));
    }*/
  }

  public getClass(bool: boolean,className: string):boolean {

    return (bool || (this.classList && this.classList.includes(className)) || (this.deviceService.isMobile() && this.classListMobile && this.classListMobile.includes(className)));
  }

}
